// Swipe-to-action row (iOS Mail / Reminders style).
// Reveals right-side action buttons when the row is dragged left.
import { motion, useMotionValue, animate } from "framer-motion";
import { useRef, useState, useEffect } from "react";

export default function SwipeableRow({
  children,
  actions = [],           // [{ label, icon, color, onClick }]
  threshold = 0.4,        // fraction of actions width to trigger snap-open
  className = "",
}) {
  const x = useMotionValue(0);
  const containerRef = useRef(null);
  const [actionsWidth, setActionsWidth] = useState(actions.length * 84);

  useEffect(() => {
    setActionsWidth(actions.length * 84);
  }, [actions.length]);

  const close = () => animate(x, 0, { type: "spring", stiffness: 400, damping: 36 });
  const open = () => animate(x, -actionsWidth, { type: "spring", stiffness: 400, damping: 36 });

  const handleDragEnd = (_e, info) => {
    if (info.offset.x < -actionsWidth * threshold || info.velocity.x < -500) {
      open();
    } else {
      close();
    }
  };

  return (
    <div ref={containerRef} className={`relative overflow-hidden bg-white ${className}`}>
      {/* Underlying actions */}
      <div className="absolute inset-y-0 right-0 flex">
        {actions.map((a, i) => (
          <button
            key={i}
            type="button"
            onClick={() => { a.onClick?.(); close(); }}
            data-testid={a.testId}
            className="px-5 flex flex-col items-center justify-center text-white text-[12px] font-semibold gap-0.5 min-w-[84px]"
            style={{ background: a.color }}
          >
            {a.icon}
            {a.label}
          </button>
        ))}
      </div>
      {/* Sliding content */}
      <motion.div
        drag="x"
        dragConstraints={{ left: -actionsWidth, right: 0 }}
        dragElastic={0.05}
        style={{ x }}
        onDragEnd={handleDragEnd}
        className="bg-white relative touch-pan-y"
      >
        {children}
      </motion.div>
    </div>
  );
}
